import Profile from "@/routes/Onboarding/Collect/Profile";
import KlaviyoApiKey from "@/routes/Onboarding/Collect/KlaviyoApiKey";
import KlaviyoOptIn from "@/routes/Onboarding/Collect/KlaviyoOptIn";
import PrivacyPolicyURL from "@/routes/Onboarding/Collect/PrivacyPolicyUrl";
import PrivacyEmail from "@/routes/Onboarding/Collect/PrivacyEmail";
import ShopifyPlacement from "@/routes/Onboarding/Collect/ShopifyPlacement";
import ShopifyDisableConsent from "@/routes/Onboarding/Collect/ShopifyDisableConsent";
import SetupComplete from "@/routes/Onboarding/Collect/SetupComplete";
import ShopifyPreview from "@/routes/Onboarding/Collect/ShopifyPreview";
import { createRef } from "react";

export const collectOnboardingRoutes = [
  {
    path: "profile",
    element: <Profile />,
    nodeRef: createRef<HTMLDivElement>(),
  },
  {
    path: "klaviyo-api-key",
    element: <KlaviyoApiKey />,
    nodeRef: createRef<HTMLDivElement>(),
  },
  {
    path: "klaviyo-opt-in",
    element: <KlaviyoOptIn />,
    nodeRef: createRef<HTMLDivElement>(),
  },
  {
    path: "privacy-policy-url",
    element: <PrivacyPolicyURL />,
    nodeRef: createRef<HTMLDivElement>(),
  },
  {
    path: "privacy-email",
    element: <PrivacyEmail />,
    nodeRef: createRef<HTMLDivElement>(),
  },
  {
    path: "add-shopify-widget",
    element: <ShopifyPlacement />,
    nodeRef: createRef<HTMLDivElement>(),
  },
  {
    path: "disable-shopify-consent",
    element: <ShopifyDisableConsent />,
    nodeRef: createRef<HTMLDivElement>(),
  },
  {
    path: "shopify-preview",
    element: <ShopifyPreview />,
    nodeRef: createRef<HTMLDivElement>(),
  },
  {
    path: "setup-complete",
    element: <SetupComplete />,
    nodeRef: createRef<HTMLDivElement>(),
  },
];
